import { createSelector } from 'reselect';
import { PARTNER_CART_STATE_KEY } from './constants';
export var selectPartnerCart = function selectPartnerCart(state) {
  return state[PARTNER_CART_STATE_KEY] || {};
};
export var getPartnerCart = createSelector(selectPartnerCart, function (partnerCart) {
  return partnerCart || {};
});
export var getPartnerCartInFlight = createSelector(getPartnerCart, function (_ref) {
  var inFlight = _ref.inFlight;
  return inFlight || false;
});
export var getPartnerCartErrors = createSelector(getPartnerCart, function (_ref2) {
  var errors = _ref2.errors;
  return errors || [];
});